import { combineReducers } from '@reduxjs/toolkit';

import cogReducer from 'modules/cog/cog-slice';
import errorsReducer from 'modules/error/error-slice';
import globalWrapperReducer from 'modules/global-wrapper/global-wrapper-slice';
import iamReducer from 'modules/iam/iam-slice';
import paymentMethodsReducer from 'modules/payment-methods/payment-methods-slice';
import sessionDetailsReducer from 'modules/session-details/session-details-slice';
import transactionsDDReducer from 'modules/transaction-dd/transactions-dd-slice';
import transactionsPaypalReducer from 'modules/transaction-paypal/transactions-paypal-slice';
import transactionsRazorpayReducer from 'modules/transaction-razorpay/transaction-razorpay-slice';
import transactionsAchReducer from 'modules/transactions-ach/transactions-ach-slice';
import transactionsCcReducer from 'modules/transactions-cc/transactions-cc-slice';
import ucsReducer from 'modules/ucs/ucs-slice';
import { COGState } from 'types/cog';
import { GlobalWrapperState } from 'types/global-wrapper';
import { IamState } from 'types/iam';
import { PaymentMethodsState } from 'types/payment-method';
import { SessionDetailsState } from 'types/session-details';
import { TransactionsAchState } from 'types/transaction-ach';
import { TransactionsDDState } from 'types/transaction-dd';
import { TransactionsPaypalState } from 'types/transaction-paypal';
import { TransactionsRazorpayState } from 'types/transaction-razorpay';
import { TransactionsCcState } from 'types/transactions-cc';
import { UCSState } from 'types/ucs';

export interface RootReducer {
  globalWrapperReducer: GlobalWrapperState;
  iamReducer: IamState;
  sessionDetailsReducer: SessionDetailsState;
  paymentMethodsReducer: PaymentMethodsState;
  transactionsCcReducer: TransactionsCcState;
  transactionsAchReducer: TransactionsAchState;
  transactionsDDReducer: TransactionsDDState;
  transactionsPaypalReducer: TransactionsPaypalState;
  transactionsRazorpayReducer: TransactionsRazorpayState;
  ucsReducer: UCSState;
  cogReducer: COGState;
}
const rootReducer = combineReducers({
  globalWrapper: globalWrapperReducer,
  sessionDetails: sessionDetailsReducer,
  iam: iamReducer,
  paymentMethods: paymentMethodsReducer,
  transactionsCc: transactionsCcReducer,
  transactionsAch: transactionsAchReducer,
  transactionsDD: transactionsDDReducer,
  transactionsPaypal: transactionsPaypalReducer,
  transactionRazorpay: transactionsRazorpayReducer,
  errors: errorsReducer,
  ucs: ucsReducer,
  cog: cogReducer,
});

export default rootReducer;
